const ALL_ADMIN_ROLES = ["super_admin", "admin", "executive"];
const KAMUser = ["kam"];
var UserType;
(function (UserType) {
    //
    UserType["VERIFICATION_ADMIN"] = "verification_admin";
    UserType["VERIFICATION_EXECUTIVE"] = "verification_executive";
    //
    UserType["FULLFILMENT_ADMIN"] = "fullfilment_admin";
    UserType["FULLFILMENT_EXECUTIVE"] = "fullfilment_executive";
    //
    UserType["IN_TRANSIT_ADMIN"] = "intransit_admin";
    UserType["IN_TRANSIT_EXECUTIVE"] = "intransit_executive";
    UserType["IN_TRANSIT_SUPPORT"] = "intransit_support";
    UserType["PP_PLACEMENT"] = "pp_placement_executive";
    UserType["PP_LOADING"] = "pp_loading_executive";
    UserType["PP_UNLOADING"] = "pp_unloading_executive";
})(UserType || (UserType = {}));
(function (UserType) {
    UserType["SUPER_ADMIN"] = "super_admin";
    UserType["INSIDER"] = "insider";
    UserType["DEVELOPER"] = "developer";
    UserType["USER"] = "user";
    UserType["KAM"] = "kam";
    UserType["ADMIN"] = "admin";
    UserType["TSM"] = "tsm";
    UserType["EXECUTIVE"] = "executive";
    UserType["RETENTION"] = "retention";
    UserType["TSO"] = "tso";
    UserType["TSO_DEMAND"] = "tso_demand";
    UserType["TSO_SUPPLY"] = "tso_supply";
    UserType["TSO_LORRY"] = "tso_lorry";
})(UserType || (UserType = {}));
var PlivoTeam;
(function (PlivoTeam) {
    PlivoTeam["VERIFICATION"] = "Verification";
    PlivoTeam["FULFILMENT"] = "Fulfilment";
    PlivoTeam["PP_PLACEMENT"] = "PP Placement";
    PlivoTeam["PP_LOADING"] = "PP Loading";
    PlivoTeam["PP_UNLOADING"] = "PP Unloading";
    // POST_PLACEMENT = "Post Placement",
    PlivoTeam["PP_SUPPORT"] = "PP Support";
    PlivoTeam["NIGHT_SHIFT"] = "Night Shift";
    PlivoTeam["CS_HELPDESK"] = "CS Helpdesk";
    PlivoTeam["RETENTION"] = "Retention";
    PlivoTeam["INSIDE_SALES_MEMBERSHIP"] = "Inside Sales Membership";
    PlivoTeam["INSIDE_SALES_CI"] = "Inside Sales CI";
})(PlivoTeam || (PlivoTeam = {}));
const SUPER_USER_LIST = [UserType.SUPER_ADMIN, UserType.INSIDER, UserType.DEVELOPER];
const USER_GROUP = {
    INTERNAL_USERS: [UserType.INSIDER, UserType.DEVELOPER],
    SUPER_USERS: SUPER_USER_LIST,
    ADMINS: [...SUPER_USER_LIST, UserType.ADMIN],
    TSO_V2: [UserType.TSO_SUPPLY, UserType.TSO_DEMAND]
};
const ALLOWED_ACTION_BY_ROLES = {
    CUSTOM_PREFERENCE_VISIBILTY: [...USER_GROUP.ADMINS, UserType.FULLFILMENT_EXECUTIVE, UserType.RETENTION],
    UNASSIGNED_TICKET_ACTION: USER_GROUP.ADMINS,
    DEACTIVATE_LOAD: [...USER_GROUP.ADMINS, UserType.FULLFILMENT_EXECUTIVE, UserType.VERIFICATION_EXECUTIVE],
    LOAD_TICKET_PROCESS_AGENT: [...USER_GROUP.ADMINS, UserType.FULLFILMENT_EXECUTIVE, UserType.VERIFICATION_EXECUTIVE],
    CANCEL_TRIP: [...USER_GROUP.ADMINS],
    CANCEL_TRIP_LIMITED_TIME: [...USER_GROUP.ADMINS, UserType.IN_TRANSIT_EXECUTIVE],
    ALLOW_QUICK_LOGOUT: [...USER_GROUP.ADMINS, UserType.TSO],
    PP_EDIT: [...USER_GROUP.ADMINS, UserType.IN_TRANSIT_ADMIN]
};

export { ALLOWED_ACTION_BY_ROLES, ALL_ADMIN_ROLES, KAMUser, PlivoTeam, USER_GROUP, UserType };
//# sourceMappingURL=authorizedUsers.js.map
